<template>
    <div class="assignment">
        <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" :icon="icon" @createForm="dialog=true"></myBreadCrumb>
        <create-dialog v-model="dialog" :item="item" @fetch="fetchData"></create-dialog>
        <v-card>
            <v-card-title>
                
            <v-spacer></v-spacer>
            <!-- <data-filter v-model="params" :filter="filter" @fetchData="fetchData">
            </data-filter> -->
            </v-card-title>
            
            <v-data-table
            :mobile-breakpoint="0"
            height="600px" fixed-header
            :headers="headers"
            :items="items"
            :page.sync="tableParams.page"
            :sort-by.sync="tableParams.sortBy"
            :sort-desc.sync="tableParams.sortDesc"
            :server-items-length="rowCount"
            :loading="isLoading"
            loading-text="Đang tải dữ liệu..."
            >
                <!-- <template v-slot:[`body.prepend`]="" >
                    <tr>
                        <td></td>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.code"></v-text-field>
                        </td>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.employeeCode"></v-text-field>
                        </td>
                        <td>
                            <v-text-field placeholder="Nhập" dense v-model="filters.employeeName"></v-text-field>
                        </td>
                        <td>
                            <v-autocomplete placeholder="Nhập" dense v-model="filters.departmentCode"
                            item-text="name" item-value="code" :items="departments" :search-input.sync="departmentSearch" hide-no-data clearable
                            @update:search-input="fetchDepartment"></v-autocomplete>
                        </td>
                        <td colspan="100%"></td>
                    </tr>
                </template> -->
                
                <template v-slot:[`item.isFeature`]="{item}" >
                    <v-icon v-if="item.isFeature" color="success">mdi-check</v-icon>
                </template>
                <template v-slot:[`item.isVisible`]="{item}" >
                    <v-icon v-if="item.isVisible" color="success">mdi-check</v-icon>
                </template>
                <template v-slot:[`item.actions`]="{item}" >
                    <v-btn x-small @click="edit(item)" class="mx-1">
                        <v-icon small>mdi-pencil</v-icon> Sửa
                    </v-btn>
                    <v-btn x-small @click="remove(item)" class="mx-1" color="error">
                        <v-icon small>mdi-trash-can</v-icon> Xóa
                    </v-btn>
                </template>
                <template v-slot:[`item.isCurrent`]="{item}" >
                    <v-icon v-if="item.isCurrent">mdi-check</v-icon>
                </template>
                <template
                    v-slot:[`item.time`]="{ item }"
                >
                    {{ formatTime(item.time) }}
                </template>
            </v-data-table>
        </v-card>
        <!-- ************** DELETE CONFIRMATION *************** -->
        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="headline">Bạn có chắc muốn xoá dữ liệu này?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogDelete=false">Thoát</v-btn>
                <v-btn color="blue darken-1" text @click="cfmDeleteItem">OK</v-btn>
                <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import myBreadCrumb from '@/components/BreadCrumb';
import DataFilter from '@/components/DataFilter';
import CreateDialog from './Create.vue';
import * as moment from "moment/moment"

export default {
    name: "Attendance",
    components: {
        myBreadCrumb,
        'data-filter': DataFilter,
        'create-dialog': CreateDialog,

    },
    props: ["breadcrumbs", "icon"],
    watch: {
        dialog(val) {
            if(!this.dialog)
                this.item=null;
        },
        tableParams: {
            handler (val) {
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler (val) {
                this.tableParams.page=1;
                this.fetchData();
            },
            deep: true,
        },

    },
    computed: {
        params: function() {
            return {...this.tableParams, ...this.filters}
        }
    },
    data () {
        return {
            ROOT_URL: "contentCategories/",

            //filter
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            filters:{
                code: null,
                employeeCode: null,
                employeeName: null,
                deparmentCode: null,
            },
            departmentSearch:null,
            departments: [],
            rowCount: 0,
            
            // VIEW DATA
            filterOpen: 1,

            //DATA TABLE
            totalItem: 0,
            items: [],
            search:"",
            options: {},
            isLoading: true,

            dialog: false, item: null,
            dialogDelete: false,
            targetItem: undefined,

            headers: [
                { text: 'Thao tác', value: 'actions', width: 200},
                { text: 'Mã', align: 'start', value: 'code', width: 200},
                { text: 'Danh mục', align: 'start', value: 'title', width: 200},
                { text: 'Đặc biệt', align: 'start', value: 'isFeature', width: 200},
                { text: 'Hiển thị', align: 'start', value: 'isVisible', width: 200},
                { text: 'Thứ tự', align: 'start', value: 'order', width: 250},
            ],
        }
    },
    methods: {
        formatTime(value) {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        },
        fetchData () {
            return http.get(this.ROOT_URL, {
                params: this.params
            })
            .then(res => {
                this.isLoading = false;
                this.items = res.data.results;
                this.rowCount = res.data.totalItem;
            })
            .catch(err => {

            })
        },
        edit(item){
            this.item = item;
            this.dialog = true;
        },
        
        remove(item){
            this.dialogDelete = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            // http.delete(this.ROOT_URL+this.targetItem.code).then(res => {
            //     this.fetchData();
            //     this.dialogDelete = false;
            // })
        },
    },
    created () {
        this.fetchData();
    },
    
}
</script>